module.exports = __webpack_public_path__ + "img/mastercard.f4095c80.svg";